/**
 * バージョン情報の詳細を表示するコンポーネント
 */
import { useTranslation } from "react-i18next";

/**
 * バージョン情報の詳細を表示するコンポーネントのインターフェース
 * @param version バージョン
 * @param id ハッシュリンク用ID
 * @param releaseDate リリース日
 * @param size ファイルサイズ
 * @param additionalFeatures 追加機能
 * @param improvements 改善変更点
 */
export interface VersionDetailsProps {
  version: string;
  id?: string;
  releaseDate?: React.ReactNode;
  size?: React.ReactNode;
  note?: React.ReactNode;
  additionalFeatures?: string[];
  improvements?: string[];
}

/**
 * バージョン情報の詳細を表示するコンポーネント
 * @returns
 */
const VersionDetails: React.FC<VersionDetailsProps> = ({
  version,
  id,
  releaseDate,
  size,
  note,
  additionalFeatures,
  improvements,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <h3 className="p-heading-3" id={id ? id : undefined}>
        {version} {releaseDate && <>Release {releaseDate}</>} {size && size}
      </h3>
      {note && note}
      {additionalFeatures && additionalFeatures.length > 0 ? (
        <>
          <h4 className="p-heading-4">{t("追加機能")}</h4>

          <ul className="c-square">
            {additionalFeatures.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </>
      ) : null}
      {improvements && improvements.length > 0 ? (
        <>
          <h4 className="p-heading-4">{t("改善変更点")}</h4>

          <ul className="c-square">
            {improvements.map((improvement, index) => (
              <li key={index}>{improvement}</li>
            ))}
          </ul>
        </>
      ) : null}
    </>
  );
};

export default VersionDetails;
